import { render, staticRenderFns } from "./AssessmentReRegistration.vue?vue&type=template&id=62258fc9&scoped=true"
import script from "./AssessmentReRegistration.vue?vue&type=script&lang=js"
export * from "./AssessmentReRegistration.vue?vue&type=script&lang=js"
import style0 from "./AssessmentReRegistration.vue?vue&type=style&index=0&id=62258fc9&prod&scoped=true&lang=css"
import style1 from "./AssessmentReRegistration.vue?vue&type=style&index=1&id=62258fc9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62258fc9",
  null
  
)

export default component.exports